// import React, { useEffect, useState, useCallback } from "react";
// import "./Landing.css";
// import { FiSearch } from "react-icons/fi";
// import { Link } from "react-router-dom";
// import { FaLongArrowAltRight, FaUserCircle } from "react-icons/fa";
// import loaderGif from "../../src/Images/images/loader.gif";
// import { BASE_URL_API_TRANX_BLOG } from "../Utils/Constant";
// import { basicauthblog } from "../Utils/Credentials";
// function MyLanding() {
//   const [cards, setCards] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isLoading, setIsLoading] = useState(false);
//   const blogsPerPage = 8;
//   const [searchTerm, setSearchTerm] = useState("");
//   const { password, username } = basicauthblog;
//   const base64Credentials =
//     typeof window === "undefined"
//       ? Buffer.from(`${username}:${password}`).toString("base64")
//       : btoa(`${username}:${password}`);
//   const Getproductblogs = useCallback(async () => {
//     if (isLoading) return;
//     setIsLoading(true);
//     try {
//       const response = await fetch(
//         `${BASE_URL_API_TRANX_BLOG}/GetAllProductBlog`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Basic ${base64Credentials}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ webid: "2" }),
//         }
//       );
//       const data = await response.json();
//       if (data.status === "0") {
//         const sortedData = [...data.data].sort(
//           (a, b) => new Date(b.created_at) - new Date(a.created_at)
//         );
//         // setCards(sortedData);
//         setCards(sortedData.reverse());
//       } else {
//         console.error("Failed to fetch blogs:", data.msg);
//       }
//     } catch (error) {
//       console.error("Error:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   }, [isLoading]);

//   useEffect(() => {
//     Getproductblogs();
//   }, []);

//   const indexOfLastBlog = currentPage * blogsPerPage;
//   const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
//   const filteredBlogs = cards.filter((item) => {
//     const lowerSearch = searchTerm.toLowerCase();
//     return (
//       item.title.toLowerCase().includes(lowerSearch) ||
//       item.excerpt.toLowerCase().includes(lowerSearch) ||
//       item.author_name.toLowerCase().includes(lowerSearch)
//     );
//   });

//   const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
//   const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);

//   const handlePrevPage = () => {
//     setCurrentPage((prev) => Math.max(prev - 1, 1));
//   };

//   const handleNextPage = () => {
//     setCurrentPage((prev) => Math.min(prev + 1, totalPages));
//   };

//   return (
//     <section className="mb-5 pe-3">
//       <h2 className="text-center">Latest Blogs</h2>
//       <div className="d-flex justify-content-center m-4">
//         <div style={{ position: "relative", width: "50%" }}>
//           <FiSearch
//             style={{
//               position: "absolute",
//               top: "50%",
//               left: "18px",
//               transform: "translateY(-50%)",
//               color: "#6c757d",
//               fontSize: "1.2rem",
//               pointerEvents: "none",
//             }}
//           />
//           <input
//             type="text"
//             className="form-control"
//             placeholder="Search by title, excerpt or author..."
//             value={searchTerm}
//             onChange={(e) => {
//               setSearchTerm(e.target.value);
//               setCurrentPage(1);
//             }}
//             style={{
//               paddingLeft: "2.5rem",
//               borderRadius: "50px",
//               boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
//               height: "3rem",
//             }}
//           />
//         </div>
//       </div>
//       {isLoading && (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 9999,
//           }}
//         >
//           <img src={loaderGif} alt="Loading..." style={{ width: "" }} />
//         </div>
//       )}
//       <div className=" m-0">
//         <div className="row p-0">
//           {currentBlogs.map((item, i) => (
//             <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 p-1" key={i}>
//               <div
//                 className="My-Landing-card"
//                 style={{
//                   backgroundColor: "#fff",
//                   display: "flex",
//                   flexDirection: "column",
//                   boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
//                   height: "100%",
//                   transition: "opacity 0.5s ease-in-out",
//                   borderRadius: "1rem",
//                 }}
//               >
//                 <img
//                   src={
//                     item.image_url ||
//                     "https://via.placeholder.com/300x200?text=No+Image"
//                   }
//                   alt={item.image_alt || item.title}
//                   title={item.image_title || ""}
//                   style={{
//                     width: "100%",
//                     height: "auto",
//                     objectFit: "contain",
//                     borderTopRightRadius: "1rem",
//                     borderTopLeftRadius: "1rem",
//                   }}
//                 />
//                 <div
//                   className="card-content"
//                   style={{ padding: "0 10px", overflow: "hidden" }}
//                 >
//                   <div className="row p-0 m-0 mt-3">
//                     <div className="col-2 p-0">
//                       <img
//                         src={item.author_image || ""}
//                         alt={item.author_name}
//                         className="rounded-circle"
//                         style={{
//                           width: "2rem",
//                           height: "2rem",
//                           objectFit: "cover",
//                         }}
//                       />
//                     </div>
//                     <div className="col d-flex align-items-center p-0">
//                       <p
//                         className="mx-2 mb-1"
//                         style={{
//                           color: "#6d6d6d",
//                           fontSize: ".9rem",
//                           fontWeight: "600",
//                         }}
//                       >
//                         {item.author_name}
//                       </p>
//                     </div>
//                   </div>
//                   <h6
//                     className="mt-1"
//                     style={{
//                       color: "#3E3232",
//                       WebkitBoxOrient: "vertical",
//                       WebkitLineClamp: 1,
//                       overflow: "hidden",
//                       display: "-webkit-box",
//                       textOverflow: "ellipsis",
//                       fontSize: "1rem",
//                     }}
//                   >
//                     {item.title}
//                   </h6>
//                   <p
//                     className="mb-2"
//                     style={{
//                       color: "#3E3232",
//                       display: "-webkit-box",
//                       WebkitBoxOrient: "vertical",
//                       WebkitLineClamp: 4,
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       fontSize: ".9rem",
//                     }}
//                   >
//                     {item.excerpt}
//                   </p>
//                   <div className="row m-0 p-0">
//                     <div className="col  p-0 d-flex justify-content-end">
//                       <Link
//                         to={`/blog/${item.slug}`}
//                         onClick={() => {
//                           sessionStorage.setItem("Slug", JSON.stringify(item));
//                         }}
//                         style={{ textDecoration: "none" }}
//                       >
//                         Read More <FaLongArrowAltRight />
//                       </Link>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Pagination Controls */}
//         <div className="d-flex justify-content-center align-items-center mt-4">
//           <button
//             className="btn btn-outline-secondary me-2"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             &lt; Prev
//           </button>
//           <span style={{ fontWeight: "600" }}>
//             Page {currentPage} of {totalPages}
//           </span>
//           <button
//             className="btn btn-outline-secondary ms-2"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//           >
//             Next &gt;
//           </button>
//         </div>
//       </div>

//     </section>
//   );
// }

// export default MyLanding;

import React, { useEffect, useState, useCallback } from "react";
import "./Landing.css";
import { FiSearch } from "react-icons/fi";
import { FaLongArrowAltRight, FaUserCircle } from "react-icons/fa";
import loaderGif from "../../src/Images/images/loader.gif";
import { BASE_URL_API_TRANX_BLOG } from "../Utils/Constant";
import { basicauthblog } from "../Utils/Credentials";
function MyLanding() {
  const [cards, setCards] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const blogsPerPage = 14;
  const [searchTerm, setSearchTerm] = useState("");
  const { password, username } = basicauthblog;
  const base64Credentials =
    typeof window === "undefined"
      ? Buffer.from(`${username}:${password}`).toString("base64")
      : btoa(`${username}:${password}`);
  const Getproductblogs = useCallback(async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANX_BLOG}/GetAllProductBlog`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ webid: "2" }),
        }
      );
      const data = await response.json();
      if (data.status === "0") {
        const sortedData = [...data.data].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        // setCards(sortedData);
        setCards(sortedData.reverse());
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  }, [isLoading]);

  useEffect(() => {
    Getproductblogs();
  }, []);

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const filteredBlogs = cards.filter((item) => {
    const lowerSearch = searchTerm.toLowerCase();
    return (
      item.title.toLowerCase().includes(lowerSearch) ||
      item.excerpt.toLowerCase().includes(lowerSearch) ||
      item.author_name.toLowerCase().includes(lowerSearch)
    );
  });

  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);
  const paginatedBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };
  const mostViewedBlogs = [...filteredBlogs]
    .sort((a, b) => (b.views || 0) - (a.views || 0))
    .slice(0, 10);
    useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, [currentPage]);
  return (
    <section className="mb-5 pe-3">
      <h2 className="text-center mb-4">Latest Blogs</h2>
      <div className="d-flex justify-content-center m-4">
        <div className="mb-4" style={{ position: "relative", width: "50%" }}>
          <FiSearch
            style={{
              position: "absolute",
              top: "50%",
              left: "18px",
              transform: "translateY(-50%)",
              color: "#6c757d",
              fontSize: "1.2rem",
              pointerEvents: "none",
            }}
          />
          <input
            type="text"
            className="form-control"
            placeholder="Search by title, excerpt or author..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
            style={{
              paddingLeft: "2.5rem",
              borderRadius: "50px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              height: "3rem",
            }}
          />
        </div>
      </div>
      {isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <img src={loaderGif} alt="Loading..." style={{ width: "" }} />
        </div>
      )}
      <div className=" m-0">
        <div className="landing-grid">
          <div className="left-column">
            {Array.from({ length: Math.ceil(paginatedBlogs.length / 5) }).map(
              (_, blockIndex) => {
                const start = blockIndex * 5;
                const blockBlogs = paginatedBlogs.slice(start, start + 5);

                return (
                  <div className="blog-row" key={blockIndex}>
                    {/* Feature Card */}
                    {blockBlogs[0] && (
                   <a
                   href={`/blog/${blockBlogs[0].slug}`}
                   className="feature-card"
                   style={{ textDecoration: "none", color: "inherit" }}
                 >
                   <img
                     src={blockBlogs[0].image_url}
                     alt={blockBlogs[0].title}
                   />
                   <div className="overlay-title">
                     {blockBlogs[0].title}
                   </div>
                 </a>
                 
                    )}

                    {/* Three Small Cards */}
                    {blockBlogs.length > 1 && (
                      <div className="three-cards">
                        {blockBlogs.slice(1, 4).map((item, i) => (
                        <a
                        key={i}
                        href={`/blog/${item.slug}`}
                        className="small-card"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <img src={item.image_url} alt={item.title} />
                        <h6 className="single-line">{item.title}</h6>
                        <p className="three-lines">{item.excerpt}</p>
                      </a>
                      
                        ))}
                      </div>
                    )}

                    {/* Image-Text Card */}
                    {blockBlogs[4] && (
                     <a
                     href={`/blog/${blockBlogs[4].slug}`}
                     className="image-text"
                     style={{ textDecoration: "none", color: "inherit" }}
                   >
                     <img
                       src={blockBlogs[4].image_url}
                       alt={blockBlogs[4].title}
                     />
                     <div>
                       <h5>{blockBlogs[4].title}</h5>
                       <p>{blockBlogs[4].excerpt}</p>
                     </div>
                   </a>
                   
                    )}
                  </div>
                );
              }
            )}
          </div>

          <div className="right-column">
            <h5 className="mb-3">🔥 Popular Blogs</h5>

            {mostViewedBlogs.map((item, i) => (
          <a
          key={i}
          href={`/blog/${item.slug}`}
          className="side-card"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <img src={item.image_url} alt={item.title} />
          <div>
            <h6 className="single-line">{item.title}</h6>
            <span className="views-count">{item.views} views</span>
          </div>
        </a>
        
            ))}
          </div>
        </div>

        <div className="d-flex justify-content-center align-items-center mt-4">
          <button
            className="btn btn-outline-secondary me-2"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            &lt; Prev
          </button>
          <span style={{ fontWeight: "600" }}>
            Page {currentPage} of {totalPages}
          </span>
          <button
            className="btn btn-outline-secondary ms-2"
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            Next &gt;
          </button>
        </div>
      </div>
    </section>
  );
}

export default MyLanding;
